<!--
 * @Date: 2020-07-29 14:12:20
 * @LastEditors: Mosuzi
 * @LastEditTime: 2020-08-07 12:28:46
 * @Description: In User Settings Edit
 * @Author: Mosuzi
-->
<template>
  <div class="input-profile">
    <cube-input
      v-if="renderInput"
      v-model="data"
      :autofocus="true"
      class="input-box"
      :maxlength="maxLength"
      :placeholder="$t(placeholder)"
    />
    <div v-else class="custom-textarea">
      <cube-textarea
        v-model="data"
        class="textarea-box"
        :autofocus="true"
        :placeholder="$t(placeholder)"
        :maxlength="maxLength"
        :indicator="false"
      />
      <div class="textarea-indicator">
        {{ data && data.length || 0 }}/200
      </div>
    </div>
    <cube-button
      :primary="true"
      class="submit-btn"
      @click="handleClick"
    >
      {{ $t('common.common.ok') }}
    </cube-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apis from '../../../api'
import ParamsCatchMixin from '@/mixin/params-catch.mixin.js'
export default {
  mixins: [ParamsCatchMixin],
  data () {
    return {
      data: '',
      placeholder: '',
      title: '',
      renderInput: true,
      maxLength: 32,
      required: false
    }
  },
  computed: {
    ...mapState({
      currentField: (state) => state.profileModule.currentField,
      userInfo: (state) => state.authModule.userInfo
    })
  },
  created() {
    if (this.currentField) {
      if (this.currentField.field) {
        this.placeholder = 'profile.placeholder.' + this.currentField.field.column.name
        this.title = this.currentField.field.column.label
        this.data = this.currentField.field.data
      }
      this.renderInput = !this.currentField.textarea
      this.maxLength = this.currentField.maxLength || 32
      this.required = this.currentField.required
    }
  },
  methods: {
    handleBack() {
      this.$router.go(-1)
    },
    handleClick() {
      if (this.required && (!this.data || this.data === '')) {
        this.$message({
          message: this.$t('profile.notice.user') + this.title + this.$t('profile.notice.notEmpty'),
          type: 'error'
        })
      } else {
        const profile = this.$lodash.cloneDeep(this.userInfo)
        if (this.currentField) {
          profile[this.currentField.field.column.name] = this.data
          const request = {
            ...apis.PERSONAL_CENTER.UPDATE_USER_USERINFO,
            params: {
              ...profile
            }
          }
          this.$request(request)
            .asyncThen(
              (resp) => {
                this.handleBack()
              },
              () => {
                this.handleBack()
              }
            )
            .asyncErrorCatch((error) => {})
        }
      }
    }
  }
}
</script>

<style lang="scss">
.input-profile {
  height: 100%;
  width: 100%;
  // padding-top: 3.14rem;
  background: $--app-body-bgColor;
  padding-top: 0.571rem;
  box-sizing: border-box;
  .input-box {
    padding: 0 .143rem;
    height: 3.143rem;
    margin-bottom: 0.571rem;
    .cube-input-field {
      height: 100%;
      padding: 0 1.143rem;
    }
  }
  .cube-input_active::after {
    border: 0 !important;
  }
  .custom-textarea {
    position: relative;
    .cube-textarea_active::after {
      border: 1PX solid $--app-input-border-color;
    }
    .textarea-box {
      height: 7.143rem;
      margin-bottom: 0.571rem;
      background: $--app-light-color;
      .cube-textarea {
        padding: 1.071rem 1.143rem;
      }
    }
    .textarea-indicator {
      position: absolute;
      bottom: 1.071rem;
      right: 1.143rem;
      font-size: .857rem;
      color: $--app-notice-color;
    }
  }
  .submit-btn {
    margin: 0 auto;
    max-width: calc(100% - 2.286rem);
    height: 2.864rem;
  }
}
</style>
